import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=0b558c3e&scoped=true&"
import script from "./SendMessage.vue?vue&type=script&lang=js&"
export * from "./SendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b558c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b558c3e')) {
      api.createRecord('0b558c3e', component.options)
    } else {
      api.reload('0b558c3e', component.options)
    }
    module.hot.accept("./SendMessage.vue?vue&type=template&id=0b558c3e&scoped=true&", function () {
      api.rerender('0b558c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Messages/SendMessage.vue"
export default component.exports